import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CandidateBuilder,
  SendShortlistRequestInterviewEmailInput,
} from '../candidates.types';

export const sendShortlistRequestInterviewEmail = (builder: CandidateBuilder) =>
  builder.mutation<void, SendShortlistRequestInterviewEmailInput>({
    query: (args) => ({
      url: '/mail/shortlist/request-interview',
      method: 'POST',
      body: args,
      responseHandler: (response) => response.text(),
    }),
    transformResponse: () => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.REQUEST_INTERVIEW
          : SuccessMessageEn.REQUEST_INTERVIEW,
        true
      );
    },
    transformErrorResponse: (err) => {
      errorHandler(
        '[sendShortlistRequestInterviewEmail]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.requestInterview
          : ErrorMessageEn.requestInterview,
        err,
        true
      );
      return err.data;
    },
  });
